// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDeKmqj_Lf19FUFLNrvGDk8kpW274bbk68",
  authDomain: "gaa-africa-international-9549f.firebaseapp.com",
  projectId: "gaa-africa-international-9549f",
  storageBucket: "gaa-africa-international-9549f.firebasestorage.app",
  messagingSenderId: "602628125349",
  appId: "1:602628125349:web:11ea411efbc566957a134c",
  measurementId: "G-KHRK5XK069"
};

const firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApps()[0];
const auth = getAuth(firebaseApp);
const provider = new GoogleAuthProvider();
const db = getFirestore(firebaseApp);

export { firebaseApp, auth, provider, db };
